import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/timeline-project-preview-timeline';

Component('tr-timeline-project-preview-timeline', {
  properties: {
    firstTodoName: String,
    secondTodoName: String,
    thirdTodoName: String,
    firstListName: String,
    secondListName: String,
    thirdListName: String,
  },

  mixins: [eventListenerMixin],

  connected() {
    const [firstTodo, secondTodo, thirdTodo] = this.querySelectorAll('.timeline-project-preview-timeline-todo');
    Object.assign(this, { firstTodo, secondTodo, thirdTodo });
    const [firstList, secondList, thirdList] = this.querySelectorAll('.timeline-project-preview-timeline-section-header');
    Object.assign(this, { firstList, secondList, thirdList });
  },

  disconnected() {
    this.stopListening();
  },

  updateTodoName(todo, name) {
    const targetTodoName = `${todo}Name`;
    this[todo].querySelector('.timeline-project-preview-timeline-todo-name').innerHTML = name;
    this[targetTodoName] = name;
  },

  updateListName(list, name) {
    const targetListName = `${list}Name`;
    this[list].querySelector('.timeline-project-preview-timeline-section-title').innerHTML = name;
    this[targetListName] = name;
  },
});
